import {
  MEETING_DATA_FAILED,
  MEETING_DATA_REQ,
  MEETING_DATA_SUCCESS,
} from "../Constant/ZoomMeetingConstant";

export const meetingDataReducer = (state = {}, { type, payload }) => {
  switch (type) {
    case MEETING_DATA_REQ: {
      return { loading: true };
    }

    case MEETING_DATA_SUCCESS: {
      return { loading: false, meetingDataRec: payload };
    }

    case MEETING_DATA_FAILED: {
      return { loaidng: false, error: payload };
    }
    default:
      return state;
  }
};
